import { execute } from './execute';

/**
 * The whole business position: sales, the cost of the stock that sold, expenses
 * and the resulting profit.
 *
 * Restricted server-side to a built-in role holding the admin tile — Super
 * Admin in practice — because it reports what the business is actually making
 * (see NodeJS/src/actions/financeActions.js). The restriction is the server's;
 * the client only decides whether it is worth asking, and must never be treated
 * as the thing enforcing it.
 *
 * The server also exposes `finance.summary`, which answers for every role with
 * payable, receivable and — with the Cash In tile — cash held. Nothing in the
 * web client displays those figures at present, so there is deliberately no
 * binding for it here; add one when a screen needs it rather than keeping an
 * unused call around.
 */
export function fetchBusinessStatus() {
  return execute('finance.businessStatus');
}
